var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkullMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V15.2192C22 15.6781 21.6877 16.0781 21.2425 16.1894L18.7575 16.8106C18.3123 16.9219 18 17.3219 18 17.7808V21C18 21.5523 17.5523 22 17 22H15.75V19C15.75 18.5858 15.4142 18.25 15 18.25C14.5858 18.25 14.25 18.5858 14.25 19V22H12.75V19C12.75 18.5858 12.4142 18.25 12 18.25C11.5858 18.25 11.25 18.5858 11.25 19V22H9.75V19C9.75 18.5858 9.41421 18.25 9 18.25C8.58579 18.25 8.25 18.5858 8.25 19V22H7C6.44772 22 6 21.5523 6 21V17.7808C6 17.3219 5.6877 16.9219 5.24254 16.8106L2.75746 16.1894C2.3123 16.0781 2 15.6781 2 15.2192V12ZM10.3109 15.5336C10.178 15.733 10.3209 16 10.5606 16H13.4394C13.6791 16 13.822 15.733 13.6891 15.5336L12.2496 13.3744C12.1309 13.1963 11.8691 13.1963 11.7504 13.3744L10.3109 15.5336ZM18 9.5C18 8.11929 16.8807 7 15.5 7C14.1193 7 13 8.11929 13 9.5C13 10.8807 14.1193 12 15.5 12C16.8807 12 18 10.8807 18 9.5ZM8.5 12C9.88071 12 11 10.8807 11 9.5C11 8.11929 9.88071 7 8.5 7C7.11929 7 6 8.11929 6 9.5C6 10.8807 7.11929 12 8.5 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkullMask);
export default __webpack_public_path__ + "static/media/skull-mask.997fa2857a5e62cb6b4f589213f2b526.svg";
export { ForwardRef as ReactComponent };